import dayjs from 'dayjs'
import countries from '../_countries'
const locale = navigator.language || navigator.userLanguage
export function guid() {
  const s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }

  return (
    s4() +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    s4() +
    s4()
  )
}

export function parseBandwidth(bandwidth) {
  const bytesArray = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  if (!bandwidth) return '0 MB'
  let index = parseInt(Math.floor(Math.log(bandwidth) / Math.log(1024)))
  const num = Math.round(bandwidth / Math.pow(1024, index, 2))
  return `${num} ${bytesArray[index]}`
}

export function generateDomain(plan_id = null) {
  const words = ['robot', 'hamster', 'shark', 'monkey']
  let domain = 'getforge.io'
  if (['free', null, undefined].includes(plan_id)) domain = 'frge.io'
  const number = Math.floor(Math.random() * 1000)
  const word = words[Math.floor(Math.random() * words.length)]
  return `${word}-${number}.${domain}`
}

export function generateDomainName() {
  const words = ['robot', 'hamster', 'shark', 'monkey']
  const number = Math.floor(Math.random() * 1000)
  const word = words[Math.floor(Math.random() * words.length)]
  return `${word}-${number}`
}

function fallbackCopyTextToClipboard(str) {
  const el = document.createElement('textarea')
  el.value = str
  el.setAttribute('readonly', '')
  el.style.position = 'absolute'
  el.style.left = '-9999px'
  document.body.appendChild(el)
  const selected =
    document.getSelection().rangeCount > 0
      ? document.getSelection().getRangeAt(0)
      : false
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
  if (selected) {
    document.getSelection().removeAllRanges()
    document.getSelection().addRange(selected)
  }
}

export async function copyToClipboard(text) {
  try {
    return await navigator.clipboard.writeText(text)
  } catch (e) {
    fallbackCopyTextToClipboard(text)
  }
}

export function getTextDate(date) {
  return date.toLocaleString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  })
}

export function getRelativeTime(date) {
  // Validate input date
  if (!date || isNaN(date.getTime())) {
    console.warn('Invalid date passed to getRelativeTime:', date)
    return 'recently'
  }

  let now = new Date()

  const SECOND = 1000
  const MINUTE = 60 * SECOND
  const HOUR = 60 * MINUTE

  let diff = now - date

  try {
    let time = date.toLocaleString(locale, { hour: 'numeric', minute: 'numeric' })

    if (diff < MINUTE) {
      if (diff < 10 * SECOND) return 'A few seconds ago'
      else return 'Less a minute ago'
    } else if (diff < HOUR) {
      let minutes = Math.floor(diff / MINUTE)
      if (minutes == 1) return `${minutes} minute ago`
      else return `${minutes} minutes ago`

      // today
    } else if (
      now.getDate() == date.getDate() &&
      now.getMonth() == date.getMonth() &&
      now.getFullYear() == date.getFullYear()
    ) {
      return `Today, at ${time}`
    } else {
      let tomorrow = new Date(date)
      tomorrow.setDate(tomorrow.getDate() + 1)

      // yesterday
      if (
        now.getDate() == tomorrow.getDate() &&
        now.getMonth() == tomorrow.getMonth() &&
        now.getFullYear() == tomorrow.getFullYear()
      )
        return `Yesterday, at ${time}`
    }

    return getTextDate(date)
  } catch (error) {
    console.warn('Error in getRelativeTime:', error, 'for date:', date)
    return 'recently'
  }
}

export function isAbsoluteURL(urlString) {
  return (
    urlString.indexOf('http://') === 0 || urlString.indexOf('https://') === 0
  )
}

export function safeJSONParse(paramString) {
  let param = {}
  try {
    if (paramString && paramString.length > 0) param = JSON.parse(paramString)
  } catch (error) {
    console.error('incompatible JSON string', error)
  }
  return param
}

export function prettyJSON(json) {
  if (json) {
    json = JSON.stringify(json, undefined, 4)
    json = json.replace(/&/g, '&').replace(/</g, '<').replace(/>/g, '>')
    return json.replace(
      /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
      function (match) {
        var cls = 'number'
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = 'key'
          } else {
            cls = 'string'
          }
        } else if (/true|false/.test(match)) {
          cls = 'boolean'
        } else if (/null/.test(match)) {
          cls = 'null'
        }
        return '<span class="' + cls + '">' + match + '</span>'
      }
    )
  }
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      const base64String = reader.result.split(',')[1]
      resolve(base64String)
    }
    reader.onerror = (error) => reject(error)
  })
}

export function getCountryLabel(countryCode) {
  const country = countries.find(({ value }) => value === countryCode)
  return country?.text || ''
}

export function getExtensionState(extensionId) {
  const extensionStateString = localStorage.getItem(extensionId)
  let extensionState = {}
  try {
    if (extensionStateString && extensionStateString.length > 0)
      extensionState = safeJSONParse(extensionStateString)
  } catch (error) {
    extensionState = {}
  }
  return extensionState
}

export function getFirstMondayAndLastSunday() {
  const today = new Date()
  const currentMonth = today.getMonth()
  const firstDayOfMonth = new Date(today.getFullYear(), currentMonth, 1)
  const lastDayOfMonth = new Date(today.getFullYear(), currentMonth + 1, 0)

  // Find the first Monday of the month
  let firstMonday = firstDayOfMonth
  while (firstMonday.getDay() !== 1) {
    firstMonday.setDate(firstMonday.getDate() + 1)
  }

  // Find the last Sunday of the month
  let lastSunday = lastDayOfMonth
  while (lastSunday.getDay() !== 0) {
    lastSunday.setDate(lastSunday.getDate() - 1)
  }

  return [
    dayjs(firstMonday).format('YYYY-MM-DD'),
    dayjs(lastSunday).format('YYYY-MM-DD'),
  ]
}

/**
 * Sanitizes user data for SDK exposure to plugins.
 * Only exposes safe, non-sensitive user information.
 * 
 * @param {Object} user - The user object from the Vuex store
 * @returns {Object|null} Sanitized user object with only safe fields, or null if user is null
 */
export function sanitizeUserForSDK(user) {
  if (!user) return null

  return {
    id: user.id,
    name: user.name,
    email: user.email,
    avatar: user.avatar,
    plan_id: user.plan_id,
    isPaid: user.isPaid,
    customPaidPlan: user.customPaidPlan,
    country: user.country,
    roles: user.roles,
    appAccess: user.appAccess,
    maximum_number_of_sites: user.maximum_number_of_sites,
    maximum_number_of_projects: user.maximum_number_of_projects,
    sites_count: user.sites_count,
    projects_count: user.projects_count,
    created_at: user.created_at,
    // Explicitly exclude sensitive fields:
    // - authentication_token
    // - githubToken
    // - bitbucketToken
    // - dropboxToken
    // - pusherChannel
    // - bandwidth
    // - buildMinutes
  }
}

/**
 * Sanitizes site data for SDK exposure to plugins.
 * Only exposes safe, non-sensitive site information.
 * 
 * @param {Object} site - The site object from the Vuex store
 * @returns {Object|null} Sanitized site object with only safe fields, or null if site is null
 */
export function sanitizeSiteForSDK(site) {
  if (!site) return null

  return {
    id: site.id,
    url: site.url,
    site_name: site.site_name,
    image: site.image,
    thumb_image_url: site.thumb_image_url,
    projectId: site.projectId,
    currentAccountId: site.currentAccountId,
    currentDeploySlug: site.currentDeploySlug,
    currentVersionId: site.currentVersionId,
    currentVersionStatus: site.currentVersionStatus,
    currentVersionScopedId: site.currentVersionScopedId,
    currentVersionDate: site.currentVersionDate,
    deployCount: site.deployCount,
    // TODO: token and deployToken should be permission-gated in the future
    // These are included for now but should require explicit SDK permissions
    token: site.token,
    deployToken: site.deployToken,
    sslEnabled: site.sslEnabled,
    use_ssl: site.use_ssl,
    forceSSLEnabled: site.forceSSLEnabled,
    updatedAt: site.updatedAt,
    userId: site.userId,
    usersPlan: site.usersPlan,
    userIds: site.userIds,
    versionIds: site.versionIds,
    appAccess: site.appAccess,
    compiler: site.compiler,
    buildCommand: site.buildCommand,
    buildFolder: site.buildFolder,
    squish: site.squish,
    phishing: site.phishing,
    kind: site.kind,
    mode: site.mode,
    parent_site_id: site.parent_site_id,
    // WARNING: environment and environments may contain sensitive data (API keys, secrets, etc.)
    // Consider removing these if plugins don't need them, or require explicit permission
    environment: site.environment,
    environments: site.environments,
    githubAutodeploy: site.githubAutodeploy,
    githubBranch: site.githubBranch,
    githubPath: site.githubPath,
    bitbucketPath: site.bitbucketPath,
    bitbucketBranch: site.bitbucketBranch,
    bitbucketAutodeploy: site.bitbucketAutodeploy,
    dropboxAutodeploy: site.dropboxAutodeploy,
    dropboxPath: site.dropboxPath,
    bandwidth: site.bandwidth,
    // Explicitly exclude sensitive fields:
    // - dropboxCursor
    // - githubWebhookId
    // - webhookTriggerIds
    // - webhookTriggers
    // - ignite_folder_added
    // - publisherInfo (may contain sensitive data)
  }
}
